import { render, staticRenderFns } from "./FilesManager.vue?vue&type=template&id=c4b07e6a&"
import script from "./FilesManager.vue?vue&type=script&lang=js&"
export * from "./FilesManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports